import React, { useEffect, useState } from 'react';
import FilterComponents from '../FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import axios from 'axios';
import { Button, Grid } from '@mui/material';
import bin from './../../../../assets/icons/recycle-binColor.png'
import filterIcon from './../../../../assets/icons/filter 1.png'
import searchIcon from './../../../../assets/icons/searchIcon 1.png'
import AddSpecification from '../AddSpecifications/AddSpecification.tsx';
import { toast } from 'react-toastify';
import ediPencil from './../../../../assets/icons/editPencil.png'
import EditSpecification from '../AddSpecifications/EditSpecifications.tsx';
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal.js';
import { Tune } from '@mui/icons-material';
import "./AddOnSetup.css";


function AddOnSetup(props) {

  const apiAddress = process.env.REACT_APP_SECRET;
  const Restauranttoken = JSON.parse(localStorage.getItem('restaurant'));
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false)
  const [open, setOpen] = useState(false)
  const handleClickOpen = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
    setOpenEditAddon(false)
  }

  const errorToast = (msg) => {
    toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  }

  const [selectedDataRows, setSelectedDataRows] = useState([])
  const getselectedData = (data) => {
    console.log(data)
    setSelectedDataRows(data)
  }


  const deleteBin = () => {
    if (!!selectedDataRows == false) {
      toast.error("please select any Keyword", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else {
      axios
        .put(apiAddress + "/api/AddOns/DeleteAddOnsMaster", selectedDataRows)
        .then((response) => {
          console.log(response.data);
          toast.success("Suuccesfully deleted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          loadAddonsByRestaurantId()
        });
    }
    setopenConfirmaitonModal(false)
  }

  const [isVatAddedSpecificationPage, setisVatAddedSpecificationPage] = useState(false)

  console.log("vat console", isVatAddedSpecificationPage,);



  const AddSpecificationVatCheck = e => {
    if (e === "") {
      setisVatAddedSpecificationPage(false);
    } else {
      setisVatAddedSpecificationPage(true);
    };
  }

  const [OpenEditAddon, setOpenEditAddon] = useState(false)
  const [EditAddonObj, setEditAddonObj] = useState()
  const [var1, setVar1] = useState(0)
  const [allAddons, setAllAddons] = useState()
  const onEditClick = (props) => {
    var list = []
    console.log("edit id:", props)
    var obj = allAddons.find(x => x.id == props)
    console.log(obj)
    axios
      .get(apiAddress + "/api/AddOns/GetAddOnsOptionSuboptionByAddonId?addonId=" + props)
      .then((response) => {
        console.log(response.data)
        response.data.addOnOptionFormViews.map((dt) => {
          var optionObj = { id: dt.addOnOptionsMaster.id, title: dt.addOnOptionsMaster.optionName }
          list.push(optionObj)
        })

      });
    obj.optionData = list
    setEditAddonObj(obj)

    setOpenEditAddon(true)
    setVar1(var1 + 1)
  }

  const [dataRows, setDataRows] = useState([])
  var ButtonStye = [
    { id: 3, buttonStyle: "Radio Button" },
    { id: 4, buttonStyle: "Check Box" },
    { id: 5, buttonStyle: "Button" },
    { id: 6, buttonStyle: "Text Box" },
  ]
  const loadAddonsByRestaurantId = async () => {
    var list = []
    await axios
      .get(apiAddress + "/api/AddOns/GetAddOnsMasterByRestaurantId?restaurantId=" + Restauranttoken.id)
      .then((response) => {
        console.log("add on data: ", response.data)
        setAllAddons(response.data)
        response.data.map((d, i) => {
          var button = ButtonStye.find(x => x.id == d.optionButtonId)
          var obj = {
            id: d.id,
            addOnid: d.id,
            addonName: d.addOnName,
            buttonStyle: button?.buttonStyle,
            basePrice: d.basePrice,
            incrementalQuantity: d.increamentalQuantity,
            maxQuantity: d.maxQuantity,
            minQuantity: d.minQuantity,
            priceInclusiveVAT: d.priceInclusiveVAT,
            vaTinPercentage: d.vaTinPercentage,
          }
          list.push(obj)
        })

      });
    setDataRows(list)
  }
  useEffect(() => {
    loadAddonsByRestaurantId()
  }, [])
  const columns = [
    // {
    //     field: 'checkbox',
    //     headerName: 'Checkbox',
    //     renderCell: () => <input type="checkbox" />,
    // },
    {
      field: "addonName",
      headerName: "Addon Name",
      align: "center",
      headerAlign: "center",
      flex: 1.5,
    },
    {
      renderCell: (params) => (
        <div className="d-flex " style={{ gap: "10px" }}>
          <span>{params.value}</span>
          <div
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => {
              onEditClick(params.row.id);
            }}
          >
            {/* <div style={{ color: "blue", cursor: "pointer" }}> */}
            <img src={ediPencil} alt="" style={{ width: "1rem" }} />
          </div>
        </div>
      ),
      flex: 0.2,
    },
    { field: 'buttonStyle', headerName: 'Button Style',align: "center", headerAlign: "center", flex: 1 },
    { field: 'basePrice', headerName: 'Base Price', align: "center", headerAlign: "center", flex: 1 },
    { field: 'incrementalQuantity', headerName: 'Incremental Quantity', align: "center", headerAlign: "center", flex: 1 },
    { field: 'maxQuantity', headerName: 'Max Quantity', align: "center", headerAlign: "center",flex: 1 },
    { field: 'minQuantity', headerName: 'Min Quantity', align: "center", headerAlign: "center",flex: 1 },
    { field: 'priceInclusiveVAT', headerName: 'Price Inclusive', align: "center", headerAlign: "center", flex: 1 },
    { field: 'vaTinPercentage', headerName: 'VAT in Percentage', align: "center", headerAlign: "center", flex: 1 }
  ];


  return (
    <div>
      <div>
        {/* <FilterComponents title={"OK"} isItem={16} /> */}
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mt={2}
          mb={2}
        >
          <SweetAlertModal headerText={"Are you sure?"} bodyText={"You want to delete this?"} open={openConfirmaitonModal} onyes={deleteBin} close={() => { setopenConfirmaitonModal(false) }} />
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Button
                  color="primary"
                  size="medium"
                  variant="contained"
                  style={{ borderRadius: '50%', minWidth: 'auto' }}
                  onClick={handleClickOpen}
                >
                  +
                </Button>
              </Grid>
              {/* <Grid item>
                <img src={filterIcon} alt="" style={{ width: '1rem' }} />
              </Grid>
              <Grid item>Add Filter</Grid> */}

              <Grid item>
                <div className='roundedCorner'>
                  <img src={bin} alt="" style={{ width: '1rem' }} onClick={() => { selectedDataRows.length == 0 ? errorToast("PLease select any addon") : setopenConfirmaitonModal(true) }} />
                </div>
              </Grid>
              <Grid item>

              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container flexDirection={'column'} alignItems={'center'}>
              {/* <Grid item>
                <img src={searchIcon} alt="" style={{ width: '1rem' }} />
              </Grid>
              <Grid item>Search</Grid> */}
            </Grid>
          </Grid>
        </Grid>
        <div className="width-full">
          <CustomDataGrid columns={columns} dataRows={dataRows} getselectedData={getselectedData} />
        </div>
        {open ? (
          <AddSpecification dialogName={"Add on"} open={open} onClose={onClose} reloadAddons={loadAddonsByRestaurantId}
            isVatAddedSpecificationPage={isVatAddedSpecificationPage} AddSpecificationVatCheck={AddSpecificationVatCheck} />
        ) : ""}

        {OpenEditAddon ? (
          <EditSpecification open={OpenEditAddon} onClose={onClose} reloadAddons={loadAddonsByRestaurantId} editData={EditAddonObj} var1={var1} setvar1={setVar1} />
        ) : ""}
      </div>
    </div>
  );
}

export default AddOnSetup; 